import { useState, useRef } from "react";
import "../auth/css/auth.css";
import logo from "../../assets/images/logo1.png";
import CustomSvg from "../svgs/CustomSvg";
import userProfile1 from "../../assets/images/userProfile1.png";
import userProfile2 from "../../assets/images/userProfile2.png";
import userProfile3 from "../../assets/images/userProfile3.png";
import userProfile4 from "../../assets/images/userProfile4.png";
import userProfile5 from "../../assets/images/userProfile5.png";
import userProfile6 from "../../assets/images/userProfile6.png";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../utils/hooks";
import { patchRequest } from "../apiRequests/requestApi";

const avatars = [
  {
    id: 1,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236728/isqsblymuv8hbb4igdc3.png',
    bgClass: "bg-FD8D84",
  },
  {
    id: 2,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236751/ztlv7t96gb2uvgrrjamt.png',
    bgClass: "bg-84FDA6",
  },
  {
    id: 3,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236761/uavwaqd5qv02w5747l9v.png',
    bgClass: "bg-B1DEFF",
  },
  {
    id: 4,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236770/y3cqqtjwddwuqpp2axjb.png',
    bgClass: "bg-C59AFC",
  },
  {
    id: 5,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236777/vbl8vuzcvskrrdbangc4.png',
    bgClass: "bg-FFD2B1",
  },
  {
    id: 6,
    profile: 'http://res.cloudinary.com/dqg3twqfg/image/upload/v1747236792/mxdo6uy322oudkkyqzan.png',
    bgClass: "bg-FD8D84",
  },
  
];

export default function SelectAvatar({ isProfileRoute }) {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  const { setUserDetails } = useUser();
  const fileInputRef = useRef(null);

  const goToDashboard = () => navigateTo("/");
  const goToEditProfile = () => navigateTo("/user-profile/");

  const [selectedAvatarId, setSelectedAvatarId] = useState();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('File size should be less than 5MB');
      return;
    }

    try {
      setIsUploading(true);
      const formData = new FormData();
      // Send the raw file with its original name and type
      formData.append('avatar', file, file.name);

      // Make sure we're sending the raw file data
      const response = await patchRequest("/auth/profile", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      // Use the URL from the server response
      setUploadedImage(response.avatar);
      setSelectedAvatarId(null); // Clear selected avatar when uploading custom image
      
      // Update user details with new avatar
      setUserDetails(prev => ({
        ...prev,
        avatar: response.avatar
      }));

      alert('Profile picture updated successfully!');
      if (isProfileRoute) {
        goToEditProfile();
      } else {
        goToDashboard();
      }
    } catch (error) {
      console.error('Error uploading avatar:', error);
      alert('Failed to upload profile picture. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };

  const handleAvatarSelect = async (id) => {
    setSelectedAvatarId(id);
    setUploadedImage(null); // Clear uploaded image when selecting avatar
    
    try {
      const selectedAvatar = avatars.find(avatar => avatar.id === id);
      if (selectedAvatar) {
        const response = await patchRequest("/auth/profile", {
          avatar: selectedAvatar.profile // This is now the Cloudinary URL
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        
        // Update user details with selected avatar
        setUserDetails(prev => ({
          ...prev,
          avatar: selectedAvatar.profile
        }));

        alert('Profile picture updated successfully!');
        if (isProfileRoute) {
          goToEditProfile();
        } else {
          goToDashboard();
        }
      }
    } catch (error) {
      console.error('Error updating avatar:', error);
      alert('Failed to update profile picture. Please try again.');
    }
  };

  const displayAvatars = avatars.map((avatar, i) => {
    const { bgClass, profile, id } = avatar;

    const isSelected = id === selectedAvatarId ? true : false;

    return (
      <div
        key={i}
        onClick={() => handleAvatarSelect(id)}
        className={`col-lg-auto col-md-auto col-auto ${bgClass} ${
          isSelected && "user-profile-edit-profile-img-container"
        } clickable mb-4 rounded-circle mx-lg-4 mx-md-4 mx-2 d-flex align-items-center justify-content-center p-1`}
      >
        <img src={profile} className="col-lg-12 col-md-12 col-12" alt="" />
      </div>
    );
  });

  const onBtnClick = () => {
    if (uploadedImage || selectedAvatarId) {
      if (isProfileRoute) {
        goToEditProfile();
      } else {
        goToDashboard();
      }
    }
  };

  return (
    <div className="email-verify-bg py-4 px-lg-5 px-md-5 px-3">
      {!isProfileRoute && (
        <div className="d-flex align-items-start flex-column mb-5">
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="mb-0 col-lg-8 d-flex align-items-center justify-content-center">
              <img src={logo} className="col-lg-12" alt="" />
            </div>
            <h3 className="regular-txt txt-FFF m-0 p-0 text-center font-family-quantico font-weight-500">
              SkyBoard
            </h3>
          </div>
        </div>
      )}

      <div className="d-flex align-items-center justify-content-center py-0">
        <div
          className={`${
            isProfileRoute ? "col-lg-12" : "col-lg-10"
          } d-flex flex-column align-items-center justify-content-center`}
        >
          <h1 className="m-0 p-0 mb-4 font-weight-700 font-family-quantico txt-FFF extra-large-txt text-center">
            Select <span className="email-verify-email-txt">Avatar</span>
          </h1>

          <p className="m-0 p-0 mb-5 opacity-_7 font-family-poppins txt-small font-weight-300 txt-FFF text-center">
            Select an avatar or upload your own profile picture
          </p>

          <div className="d-flex mb-5 align-items-center justify-content-between flex-wrap">
            {displayAvatars}
          </div>

          <div className="w-100 d-flex flex-column align-items-center mb-5">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              accept="image/*"
              style={{ display: 'none' }}
            />
            <button
              onClick={() => fileInputRef.current?.click()}
              className="w-lg-50 w-md-50 w-75 bg-BD3193 d-flex align-items-center justify-content-center p-2 mb-3"
              disabled={isUploading}
            >
              {isUploading ? (
                <div className="d-flex align-items-center">
                  <div className="spinner-border spinner-border-sm text-white me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins">
                    Uploading...
                  </p>
                </div>
              ) : (
                <>
                  <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
                    Upload Custom Picture
                  </p>
                  <div className="m-0 p-0 mx-2 d-flex align-items-center">
                    <CustomSvg name={"arrow-right"} />
                  </div>
                </>
              )}
            </button>
            {uploadedImage && (
              <div className="mt-3">
                <img
                  src={uploadedImage}
                  alt="Uploaded"
                  style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover' }}
                />
              </div>
            )}
          </div>

          {/* <button
            onClick={onBtnClick}
            disabled={!uploadedImage && !selectedAvatarId}
            style={{
              opacity: (uploadedImage || selectedAvatarId) ? 1 : 0.5,
            }}
            className="w-lg-50 w-md-50 w-75 bg-BD3193 d-flex align-items-center justify-content-center p-2 mb-5"
          >
            <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
              {(uploadedImage || selectedAvatarId) ? "Continue" : "Select an avatar or upload a picture"}
            </p>
            {(uploadedImage || selectedAvatarId) && (
              <div className="m-0 p-0 mx-2 d-flex align-items-center">
                <CustomSvg name={"arrow-right"} />
              </div>
            )}
          </button> */}
        </div>
      </div>
    </div>
  );
}
